import { ButtonComponentConfig } from './button-component-config.interface';
import { ButtonType } from './button-type.enum';

export const PRIMARY_SAVE_BUTTON_CONFIG: ButtonComponentConfig = {
  text: 'SHARED.SAVE',
  type: ButtonType.Primary
};
